/**
 * Session token + cached user for the SPA.
 * All API auth uses Bearer token from storage — the user JSON alone does not authenticate requests.
 * We read localStorage first, then sessionStorage (migrate to localStorage so one source wins).
 */

export const AUTH_TOKEN_KEY = 'auth_token';
export const AUTH_USER_KEY = 'auth_user';

export function getAuthTokenFromStorage() {
  try {
    let t = localStorage.getItem(AUTH_TOKEN_KEY);
    if (t && typeof t === 'string' && t.trim()) return t.trim();
    t = sessionStorage.getItem(AUTH_TOKEN_KEY);
    if (t && typeof t === 'string' && t.trim()) {
      const trimmed = t.trim();
      try {
        localStorage.setItem(AUTH_TOKEN_KEY, trimmed);
        sessionStorage.removeItem(AUTH_TOKEN_KEY);
      } catch (_) {
        /* ignore */
      }
      return trimmed;
    }
  } catch (_) {
    /* ignore */
  }
  return null;
}

/** @returns {{ raw: string } | null} */
export function getAuthUserRawFromStorage() {
  try {
    let raw = localStorage.getItem(AUTH_USER_KEY);
    if (raw) return { raw };
    raw = sessionStorage.getItem(AUTH_USER_KEY);
    if (raw) {
      try {
        localStorage.setItem(AUTH_USER_KEY, raw);
        sessionStorage.removeItem(AUTH_USER_KEY);
      } catch (_) {
        /* ignore */
      }
      return { raw };
    }
  } catch (_) {
    /* ignore */
  }
  return null;
}

export function clearAuthPersistence() {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_USER_KEY);
    sessionStorage.removeItem(AUTH_TOKEN_KEY);
    sessionStorage.removeItem(AUTH_USER_KEY);
  } catch (_) {
    /* ignore */
  }
}

export function persistAuthSession(token, userObject) {
  try {
    const t = String(token || '').trim();
    if (!t) return;
    localStorage.setItem(AUTH_TOKEN_KEY, t);
    if (userObject != null) {
      localStorage.setItem(AUTH_USER_KEY, JSON.stringify(userObject));
    }
    sessionStorage.removeItem(AUTH_TOKEN_KEY);
    sessionStorage.removeItem(AUTH_USER_KEY);
  } catch (_) {
    /* ignore */
  }
}

export function persistUserCache(userObject) {
  try {
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(userObject));
  } catch (_) {
    /* ignore */
  }
}
